import React from "react";

const Checkbox = React.forwardRef(({ label, ...props }, ref) => {
  return (
    <div className="flex items-center">
      <input
        type="checkbox"
        className="h-4 w-4 rounded-[4px] border-ink-300 text-accent-500 focus:ring-accent-500/30 focus:ring-2 focus:ring-offset-0"
        ref={ref}
        {...props}
      />
      <label
        htmlFor={props.id}
        className="ml-3 block text-sm leading-6 text-ink-900"
      >
        {label}
      </label>
    </div>
  );
});
export default Checkbox;
